import { memo, type FunctionComponent } from 'react';
import map from 'lodash/map';
import toString from 'lodash/toString';
// Material UI imports
import Box from '@mui/material/Box';
// Skillmore UI Components
import { shape } from '@empathco/ui-components/src/styles/themeOptions';
// local imports
import { Skill } from '../models/skill';
import SkillChip from '../elements/SkillChip';
import JobSkillsResetButton from '../elements/JobSkillsResetButton';

type SkillsSelectionVariant = 'default' | 'analytics'; // TODO: `default` is unused

type EditJobAdvancedSkillsProps = {
  readonly variant?: SkillsSelectionVariant;
  readonly skills: Skill[];
  readonly advancedIds: Record<string, boolean>;
  readonly onActivate: (id: number) => void;
  readonly onApply?: () => void;
  readonly onReset?: () => void;
  readonly disabled?: boolean | null;
  readonly disableUnselected?: boolean;
}

const EditJobAdvancedSkills: FunctionComponent<EditJobAdvancedSkillsProps> = ({
  variant = 'default',
  skills,
  advancedIds,
  onActivate,
  onApply,
  onReset,
  disabled = false,
  disableUnselected = false
}) => {
  const isAnalytics = variant === 'analytics';
  return (
    <Box
        bgcolor={isAnalytics ? 'background.dashboard' : 'background.darker'}
        display="flex"
        flexWrap="wrap"
        justifyContent={isAnalytics ? undefined : 'center'}
        p={1}
        borderRadius={shape.tinyBorderRadius}
    >
      {map(skills, (skill) => {
        const active = advancedIds[toString(skill.id)] || undefined;
        return (
          <SkillChip
              key={skill.id}
              skill={skill}
              active={active}
              onActivate={onActivate}
              disabled={disabled || (disableUnselected && !active) ? true : undefined}
          />
        );
      })}
      {isAnalytics ? (
        <JobSkillsResetButton
            title="hr.dashboard.button.apply"
            onReset={onApply}
            disabled={disabled}
        />
      ) : undefined}
      <JobSkillsResetButton
          onReset={onReset}
          disabled={disabled}
      />
    </Box>
  );
};

export default memo(EditJobAdvancedSkills);
